// BH cart shipping progress — re-renders the threshold UI on cart change.
// Listens for Shogun/Lorenza cart:updated events AND patches fetch/XHR for /cart/* responses
// so we catch updates regardless of which path the theme uses.

(function () {
  var THRESHOLD = 25000; // cents
  var SHOW_FROM = 20000;
  var BRAND_TEXT = '#352619';
  var BRAND_ACCENT = '#5E3654';

  function render(totalCents) {
    var container = document.querySelector('[data-bh-ship-progress]');
    if (!container) return;
    if (totalCents >= THRESHOLD) {
      container.innerHTML = '<p class="bh-ship-progress__msg bh-ship-progress__msg--unlocked">Free shipping unlocked &#10003;</p>';
    } else if (totalCents >= SHOW_FROM) {
      var remaining = THRESHOLD - totalCents;
      var pct = Math.round(totalCents * 100 / THRESHOLD);
      var dollars = '$' + (remaining / 100).toFixed(2).replace(/\.00$/, '');
      container.innerHTML =
        '<p class="bh-ship-progress__msg">Just <strong>' + dollars + '</strong> away from free shipping</p>' +
        '<div class="bh-ship-progress__bar"><div class="bh-ship-progress__fill" style="width:' + pct + '%"></div></div>';
    } else {
      container.innerHTML = '';
    }
  }

  function refreshFromCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && typeof cart.total_price === 'number') render(cart.total_price); })
      .catch(function () {});
  }

  // Listen for any cart-mutating fetch — refresh after
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var p = _fetch.apply(this, arguments);
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refreshFromCart, 60); }).catch(function () {});
      }
      return p;
    };
  }

  // Same for XHR (some themes use XHR not fetch)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bhCartMutation = /\/cart\/(add|change|update|clear)/.test(url || '');
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (this.__bhCartMutation) {
      this.addEventListener('load', function () { setTimeout(refreshFromCart, 60); });
    }
    return origSend.apply(this, arguments);
  };

  // Initial render confirms in-sync state when drawer opens
  document.addEventListener('DOMContentLoaded', refreshFromCart);
  // Also listen for theme-specific drawer-open events
  ['cart:open', 'cart:updated', 'quick-cart:opened'].forEach(function (ev) {
    document.addEventListener(ev, refreshFromCart);
  });
})();
